export default "__VITE_ASSET__MIOtZMPW__"